module.exports = __webpack_public_path__ + "img/security.cb0427d5.jpg";